import React from 'react'
import "./TokenCard.css";
import tokenImg from "../../assets/token.webp"
import arrowIcon from "../../assets/Button.png"

export default function TokenCard(props) {

    const openModal = ()=>{
        props.setIsModalOpen(true);

    }
  return (
    <>
        <div className='tokenCard' onClick={()=>openModal()}>
            <div className='tokenData'>
                <div className='tokenWritten'>
                    <h3>
                        Alfred Token
                    </h3>
                    <h5>
                        @Hotel Name
                    </h5>
                    <h6>
                    Jan'26 - Jan'28 <span style={{color: "black"}}>•</span> 4 People
                    </h6>
                    <p>
                    South West Mumbai Andheri near dadra nagar haveli.
                    </p>
                    {/* <button>
                        Redeem Now
                    </button> */}
                </div>
                <div className='tokenImg'>
                    <img src={tokenImg} alt="Error" />
                    <img src={arrowIcon} alt="Error" className='tokenArrow' />
                </div>
            </div>
        </div>
    </>
  )
}
